import { TWidgetPlan } from '@entities/widget-shop/model/types';

export const findWidgetPlan = ({
    widgetPlans,
    widgetPlanId,
}: {
    widgetPlans: TWidgetPlan[];
    widgetPlanId: TWidgetPlan['id'];
}): TWidgetPlan | null => {
    const foundPlan = widgetPlans.find((plan) => widgetPlanId === plan.id);
    if (!foundPlan) {
        return null;
    }
    return foundPlan;
};
